import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';
import { Notifications } from '@sorare/gameplay/src/components/activity/Notifications';

const Activity = () => {
  return (
    <RequireAuth>
      <Notifications />
    </RequireAuth>
  );
};

export default Activity;
